<template>
  <div>
    <div class="dashboard-head-bg"/>
    <div class="dashboard-head-content">
      <DashboardHeader :firstname=firstname :profile-picture-url=profilePictureUrl />
      <div class="dashboard-status">
        <div class="dashboard-status-content">
          <div class="dashboard-status-content-label">
            Aucune candidature déposée
          </div>
          <div class="dashboard-status-content-progress">
            <ve-progress
                :progress="purcentage"
                :size="100"
                color="#CBDB2A"
                emptyThickness="10%"
                line="square"
                thickness="0%"
            >
              <span class="dashboard-status-content-progress-legend">{{ purcentage }}%</span>
            </ve-progress>
          </div>
        </div>
      </div>
    </div>

    <div class="dashboard-container">
      <div class="dashboard-section" v-if="comments !== ''">
        <div class="dashboard-section-header">
          <div class="dashboard-section-header-title"><img src="@/assets/img/raster.png">Un commentaire a été déposé sur votre espace</div>
          <div><img class="dashboard-section-header-underline" src="@/assets/img/underline.png"></div>
        </div>
        <div class="dashboard-section-content">
          <div class="dashboard-section-content-italic">
            <pre>{{comments}}</pre>
          </div>
        </div>
      </div>

      <div class="dashboard-section" v-if="ofVacationDateAsString !== ''">
        <div class="dashboard-section-header">
          <div class="dashboard-section-header-title"><img src="@/assets/img/raster.png">Congés annuels de votre centre de rattachement</div>
          <div><img class="dashboard-section-header-underline" src="@/assets/img/underline.png"></div>
        </div>
        <div class="dashboard-section-content">
          <div class="dashboard-section-content-italic">
            <pre>{{ ofVacationDateAsString }}</pre>
          </div>
        </div>
      </div>


      <div class="dashboard-section">
        <div class="dashboard-section-header">
          <div class="dashboard-section-header-title"><img src="@/assets/img/raster.png">Important</div>
          <div><img class="dashboard-section-header-underline" src="@/assets/img/underline.png"></div>
        </div>
        <div class="dashboard-section-content">
          <div class="dashboard-section-content-italic">
            Avant de déposer votre dossier de candidature, quelques informations importantes :
          </div>
          <div class="dashboard-section-content-steps">
            <div class="dashboard-section-content-steps-row">
              <div><img class="raster" src="@/assets/img/plus.png"></div>
              <div>Préparez votre CV et attestation de stage d'immersion au format .pdf</div>
            </div>
            <div class="dashboard-section-content-steps-row">
              <div><img class="raster" src="@/assets/img/plus.png"></div>
              <div>Préparer votre photo et votre diplôme</div>
            </div>
            <div class="dashboard-section-content-steps-row">
              <div><img class="raster" src="@/assets/img/plus.png"></div>
              <div>Préparez le contenu de votre lettre de motivation à destination des futurs employeurs vétérinaires qui sera à renseigner dans le champ prévu à cet effet</div>
            </div>
          </div>
          <div class="dashboard-section-content-italic">
            Votre dossier de candidature sera automatiquement affecté et traité par un centre de formation <b>APFORM</b> selon votre domicile.
          </div>
        </div>
      </div>

      <div class="form-group">
        <button button class="btn btn-primary btn-block" @click="toFile">
          <span>Déposer ma candidature</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>

import DashboardHeader from '@/components/Dashboard/Header.vue'

export default {
  name: "DashboardNoCandidature",
  components: {
    DashboardHeader
  },
  props: {
    firstname: String,
    purcentage: Number,
    comments: String,
    ofVacationDateAsString: String,
    profilePictureUrl: String,
  },
  methods: {
    toFile: function () {
      this.$router.push({name: 'file'});
    }
  },
};

</script>
